var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"lg":"9"}},[_c('b-card',[_c('b-card-text',{staticClass:"text-center"},[_c('h2',[_vm._v("Welcome to Itech CV")])])],1)],1),_c('b-col',{attrs:{"lg":"3"}},[_c('Thread')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }